import { FundabilityNarrative } from "@cxm/client";
import { CheckCircle2, XCircle } from "lucide-react";

const FundabilityBreakdown = (
  { narrative }: { narrative: FundabilityNarrative[] },
) => {
  return (
    <>
      {narrative.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Pros Column */}
          <div className="space-y-3">
            <h3 className="text-base font-medium text-green-600">
              Strengths
            </h3>
            {narrative
              .filter((item) => item.impact === "Positive")
              .slice(0, 3)
              .map((item, index) => (
                <div
                  key={`positive-${index}`}
                  className="flex items-start space-x-3 p-4 bg-green-50 rounded-lg border border-green-200 transition-all duration-300 hover:shadow-sm"
                >
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white flex items-center justify-center shadow-sm">
                    <CheckCircle2 className="h-4 w-4 text-green-500" />
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-700">
                      {item.narrativeText}
                    </p>
                  </div>
                </div>
              ))}
            {narrative.filter((
              item,
            ) => item.impact === "Positive"
            ).length === 0 && (
                <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="text-gray-500 text-sm italic">
                    No strengths identified
                  </p>
                </div>
              )}
          </div>

          {/* Cons Column */}
          <div className="space-y-3">
            <h3 className="text-base font-medium text-red-600">
              Weaknesses
            </h3>
            {narrative
              .filter((item) => item.impact === "Negative")
              .slice(0, 3)
              .map((item, index) => (
                <div
                  key={`negative-${index}`}
                  className="flex items-start space-x-3 p-4 bg-red-50 rounded-lg border border-red-200 transition-all duration-300 hover:shadow-sm"
                >
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white flex items-center justify-center shadow-sm">
                    <XCircle className="h-4 w-4 text-red-500" />
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-700">
                      {item.narrativeText}
                    </p>
                  </div>
                </div>
              ))}
            {narrative.filter((
              item,
            ) => item.impact === "Negative"
            ).length === 0 && (
                <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="text-gray-500 text-sm italic">
                    No areas for improvement identified
                  </p>
                </div>
              )}
          </div>
        </div>
      )}
    </>
  );
};

export default FundabilityBreakdown;
